import {
  administratorRoleId,
  accountOwnerRoleId,
  teamLeaderRoleId,
  memberRoleId
} from "settings";

export const getRoleNameFromId = (roleId: number) => {
  switch (roleId) {
    case administratorRoleId:
      return "Administrator";
    case accountOwnerRoleId:
      return "Account Owner";
    case teamLeaderRoleId:
      return "Team Leader";
    case memberRoleId:
      return "Member";
  }
};
